import AccessBackground from '../atoms/container/accessBackground';
import ConfirmButton from '../atoms/buttons/confirmButton';
import ErrorTitleText from '../atoms/text/errorTitleText';
import ErrorSubtitleText from '../atoms/text/errorSubtitleText';
import ErrorButtonContainer from '../atoms/text/errorButtonContainer';
import TranslationManager from '../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../shared/components/utils/hooks/useKeyboard';
import { ILoginDataError } from '../../../shared/types/interfaces/error';

function TError({ action, message }: ILoginDataError) {
  useKeyboard({
    canBeFocused: false,
    stopPropagation: true,
    keyDownHandler: (key) => {
      if (key === 'SELECT') {
        action && action();
      }
    },
  });

  return (
    <AccessBackground>
      <ErrorTitleText>
        {TranslationManager.get('MISC.ERRORS.LOGIN')}
      </ErrorTitleText>
      <ErrorSubtitleText>{message}</ErrorSubtitleText>
      <ErrorButtonContainer onClick={() => action && action()}>
        <ConfirmButton>{TranslationManager.get('MISC.CONTINUE')}</ConfirmButton>
      </ErrorButtonContainer>
    </AccessBackground>
  );
}

export default TError;
